import LineMobileAndroidIcon from 'LuxKit/Icons/line/LineMobileAndroidIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { useIntl } from 'react-intl'

function BedbankMobileOnlyPriceLabel() {
  const intl = useIntl()
  return <PromotionLabel icon={<LineMobileAndroidIcon />}>
    {intl.formatMessage({
      id: 'ciwtuF4FtscTFQMglpH3',
      defaultMessage: 'Mobile only price',
      description: 'Label indicating that a special discounted price is available only on mobile devices',
    })}
  </PromotionLabel>
}

export default BedbankMobileOnlyPriceLabel
